import React from 'react'
import Section from '../components/Section'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'
import PaypalLogo from '../assets/images/paypal-logo.jpg'
import AfterpayLogo from '../assets/images/afterpay-logo.png'
import '../assets/styles/checkout-process.css'

class Payment extends React.Component {
	componentDidMount() {
		document.querySelector('#sticky .col-md-10').style.display = 'none'
		document.querySelector('#sticky .col-md-2').style.display = 'none'
	}
	render() {
		return (
			<div className='main-container'>
				<section className='height-auto'>
					<div className='container'>
						<div className='row justify-content-center'>
							<span className='process-list__item col-md-3 col-12'>
								<h4 className='text-center'>
									<a href='/shipping'>Shipping Info</a>
								</h4>
							</span>
							<span className='process-list__item col-md-3 col-12'>
								<span className='process-list__middot' />
								<h4 className=' text-center'>
									<a href='/payment'>Payment</a>
									<hr />
								</h4>
								<span className='process-list__middot' />
							</span>
							<span className='process-list__item col-md-3 col-12'>
								<h4 className='text-center'>
									<a href='/confirmation'>Confirmation</a>
								</h4>
							</span>
						</div>
					</div>
				</section>

				{/* <Section id='login__section' className='pos--relative'>
				<div className='col-md-6'>
					<h4 className='light '>Save Your Progress</h4>
					<p>
						Login to autocomplete required information and speed up
						the checkout process. Or use super fast social media
						authorization
					</p>
				</div>
				<div className='col-md-3'>
					<a href='/'>
						<FAI
							icon={['fab', 'facebook-square']}
							size='2x'
							color='rgb(74, 74, 74)'
						/>
						<h4 className=''>Facebook Login</h4>
					</a>
				</div>
				<div className='col-md-3'>
					<a href='/'>
						<FAI
							icon={['fab', 'instagram']}
							size='2x'
							color='rgb(74, 74, 74)'
						/>
						<h4 className=''>Instagram Login</h4>
					</a>
				</div>
			</Section> */}

				<Section id='fast-pay__section'>
					<div className='col-md-6 col-12'>
						<h3>Fast Pay Options</h3>
						<p className='text--muted'>
							Pay using your PayPal or Stripe account. You will be
							redirected to one of these systems respectivley to
							complete the payment.
						</p>
					</div>
					<div className='col-md-6 col-12'>
						<div className='row'>
							<div className='col-md-5 text-center'>
								<a
									href='/#'
									target='_blank'
									rel='noopener noreferrer'>
									<img
										src={PaypalLogo}
										alt='PayPal Payment Button'
									/>
								</a>
							</div>
							<div className='col-md-5 text-center'>
								<a
									href='/#'
									target='_blank'
									rel='noopener noreferrer'>
									<img
										src={AfterpayLogo}
										alt='Afterpay Payment Button'
									/>
								</a>
							</div>
						</div>
					</div>
				</Section>

				<Section id='card-info__section'>
					<div className='col-12'>
						<h3>Credit/Debit Card Payment</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						<div className='row'>
							<div className='col-12'>
								<span className='text-muted'>
									We Proudly Accept:
								</span>
								<FAI
									icon={['fab', 'cc-mastercard']}
									size='3x'
								/>
								<FAI icon={['fab', 'cc-visa']} size='3x' />
								<FAI icon={['fab', 'cc-discover']} size='3x' />
								<FAI icon={['fab', 'cc-amex']} size='3x' />
							</div>
						</div>
						<form action='POST'>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='cardName'>
										Name on card
									</label>
									<input
										type='text'
										className='form-control'
										id='cardName'
										aria-describedby='cardName'
										placeholder='Marcela Garcia'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='cardNumber'>
										Card number
									</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='cardNumber'
										aria-describedby='cardNumber'
										placeholder='xxxx-xxxx-xxxx-xxxx'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-md-3'>
									<label htmlFor='expiryDate'>
										Expiry Date
									</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='expiryDate'
										aria-describedby='cardNumber'
										placeholder='mm/yy'
									/>
								</div>
								<div className='form-group col-md-3'>
									<label htmlFor='cardCVV'>CVV</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='cardCVV'
										aria-describedby='cardNumber'
										placeholder='xxx'
									/>
								</div>
								<div className='form-group col-md-3'>
									<label htmlFor='cardZip'>
										Billing Zip Code
									</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='cardZip'
										aria-describedby='cardNumber'
										placeholder='xxxxx'
									/>
								</div>
							</div>
						</form>
					</div>
				</Section>

				<Section id='proceed__section'>
					<div className='col-12 text-right'>
						<a href='/confirmation' className='btn btn--primary'>
							<span className='btn__text'>
								Proceed to Confirmation
							</span>
						</a>
					</div>
				</Section>

				<Section id='usp__section'>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='lock' size='2x' />
							<div className='feature__body'>
								<h4 className=''>Secure Shopping</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='credit-card' size='2x' />
							<div className='feature__body'>
								<h4 className=''>Payment Options</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='undo-alt' size='2x' />
							<div className='feature__body'>
								<h4 className=''>2-Week Returns</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
				</Section>
			</div>
		)
	}
}

export default Payment
